import axiosInstance from '../../services/axiosMiddleware';

export async function getPranayammas(courseid) {
  try {
const response = await axiosInstance.post('/pranayamma/pranayamma', courseid);

    console.log(courseid)

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
